export default __webpack_public_path__ + "static/media/Video.a6a83a74.png";